/**
 * Guest-facing portal help + invite how-to — shared by invite email and
 * portal-web Help sheet. Positive voice only; never frame by exclusion.
 *
 * @see docs/superpowers/specs/2026-08-14-portal-novice-help-design.md
 * @see docs/comms/2026-08-14-portal-how-it-works-gop.md
 */
export const GOP_PORTAL_WELCOME_SUBJECT = "Welcome to your Transition33 portal";
/** Plain-language bullets for invite HTML and in-portal Help. */
export const GOP_PORTAL_WELCOME_GUIDE = {
    heading: "How your GoP portal works",
    intro: "You have been given access to the GoP customer portal. Here is a short guide.",
    sections: [
        {
            title: "How you sign in",
            bullets: [
                "Use the button in this email (or request a new sign-in link anytime from the portal sign-in page).",
                "Click the link in your email — you are signed in. There is no password to remember.",
                "Links expire after 24 hours; request a fresh one if needed.",
            ],
        },
        {
            title: "What you will find",
            bullets: [
                "Materials Latitude30 has shared for this engagement — for example documents in shared folders, your project or engagement plan and milestones, and published board packs, signatures, or meetings when ready.",
                "Where available: briefs, discussion topics, and documents for your review.",
                "If something you expected is missing, contact your Latitude30 lead and they will share it when it is ready.",
            ],
        },
        {
            title: "Working together",
            bullets: [
                "Download shared files from the portal when available.",
                "Use review or comment features where they appear on a shared document.",
                "If something is missing, ask your Latitude30 contact — they publish updates from our side.",
            ],
        },
    ],
    closing: "If a sign-in link fails or access looks wrong, contact your Latitude30 lead and we will re-issue access.",
};
/** In-portal Help sheet title. */
export const PORTAL_HELP_TITLE = "Need help?";
export const PORTAL_HELP_AREAS_HEADING = "What each area is for";
export const PORTAL_HELP_AREAS = [
    {
        id: "home",
        title: "Home",
        description: "What needs your attention, where the programme stands, and how to reach Latitude30.",
    },
    {
        id: "shared",
        title: "Shared documents",
        description: "Files Latitude30 has shared with you for this engagement.",
    },
    {
        id: "review",
        title: "For review",
        description: "Documents waiting for your feedback or comment.",
    },
    {
        id: "programme",
        title: "Programme and plan",
        description: "Brief, engagement plan, milestones, committees & working groups, and related programme pages.",
    },
    {
        id: "send",
        title: "Send materials",
        description: "Messages and files you send back to Latitude30.",
    },
];
export const PORTAL_HELP_SIGN_IN_HEADING = "Signing in again";
export const PORTAL_HELP_SIGN_IN_BULLETS = [
    "Open the portal sign-in page and enter your work email.",
    "Request a sign-in link — check your email and click the link. There is no password.",
    "Links expire after 24 hours; request a fresh one anytime from the sign-in page.",
];
export const PORTAL_HELP_REPLAY_LABEL = "Show me the overview again";
export const PORTAL_HELP_REPLAY_HINT = "Reopens the short three-part overview of what this portal is for.";
export const PORTAL_HELP_CONTACT_HEADING = "Contact Latitude30";
export const PORTAL_HELP_CONTACT_FALLBACK = "If you are stuck or something looks wrong, contact your Latitude30 lead and they will help.";
/** One calm sentence under main page titles. */
export const PAGE_CAPTIONS = {
    home: "Your relationship desk — what needs you, where the programme stands, and how to reach Latitude30.",
    documents: "Documents Latitude30 has shared with you for this engagement.",
    forReview: "Documents shared for your review and comment.",
    published: "Items Latitude30 has published for you — packs, signatures, meetings, and similar.",
    engagementPlan: "The engagement plan and milestones Latitude30 maintains with you.",
    projectPlan: "Your project or retainer plan as shared by Latitude30.",
    workingGroups: "Committees and working groups you belong to — TOR, meetings, minutes, and actions.",
    board: "Board materials shared with you for this engagement.",
    calendar: "Upcoming meetings and sessions shared with you.",
};
export const EMPTY_WORKING_GROUPS = "When Latitude30 adds you to a committee or working group, it will appear here.";
//# sourceMappingURL=portal-guest-help.js.map